import { MarketplaceSource } from '@/types/MarketplaceSource';

export const getProductsIndexName = () => {
  return process.env.PRODUCTS_INDEX_NAME || '';
};

export const getListingsIndexName = () => {
  return process.env.LISTINGS_INDEX_NAME || '';
};

export const getSellerInventoryIndexName = () => {
  return process.env.SELLER_INVENTORY_INDEX_NAME || '';
};

const containsTag = (tags: string[], tag: string) => {
  return tags.includes(tag);
};

export const isNewListing = <L extends { _tags: string[] }>(listing: L) => {
  return !!listing && containsTag(listing._tags, 'New');
};

export const isTrendingListing = <L extends { _tags: string[] }>(listing: L) => {
  return !!listing && containsTag(listing._tags, 'Trending');
};

// it may make sense to move this type and function to a more general location
// if it's used by more than algolia results
type MarketplaceSourceEnabledObject = {
  marketplaceSources: MarketplaceSource[];
};

export const hasAmazonMarketplaceData = (obj: MarketplaceSourceEnabledObject) => {
  return obj.marketplaceSources?.includes(MarketplaceSource.AMAZON);
};

export const isGoodForStockXListing = <L extends { _tags: string[] }>(listing: L) => {
  return !!listing && containsTag(listing._tags, 'StockX');
};
